import { render, staticRenderFns } from "./empresa.vue?vue&type=template&id=f698f566&scoped=true&"
import script from "./empresa.vue?vue&type=script&lang=js&"
export * from "./empresa.vue?vue&type=script&lang=js&"
import style0 from "./empresa.vue?vue&type=style&index=0&id=f698f566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f698f566",
  null
  
)

export default component.exports